import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import './_styles/theme.css';
// theme-color meta sync at startup; no eager route imports theme now.
import './_helpers/theme';
import { Alert } from 'react-bootstrap';
import App from './App';
import './App.scss';
import { store } from './_redux/store';
import { isIE } from 'react-device-detect';
import * as serviceWorkerRegistration from './service_worker_registration';
import { setDeferredPrompt, clearDeferredPrompt } from './install_prompt_cache';
import { forceReloadWithCacheBust } from './_helpers/misc_functions';
import 'react-datepicker/dist/react-datepicker.css';
import { BrowserRouter } from 'react-router';
import { setupAxiosInterceptors } from './_helpers/axios_instance';
import { setupUtilizationTracking } from './_helpers/UtilityReactComponents/UtilizationTracking';
import { logout } from './_redux/_slices/authentication_slice';

window.addEventListener('error', (e) => {
  const isChunkLoadError =
    e?.message?.includes('ChunkLoadError') ||
    e?.error?.name === 'ChunkLoadError';
  if (isChunkLoadError) {
    console.warn('ChunkLoadError caught — forcing cache-busting reload...');
    forceReloadWithCacheBust();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event?.reason;
  const isChunkLoadError =
    reason?.message?.includes('ChunkLoadError') ||
    reason?.name === 'ChunkLoadError';
  if (isChunkLoadError) {
    console.warn('Unhandled ChunkLoadError — forcing cache-busting reload...');
    forceReloadWithCacheBust();
  }
});

// Suppress Chrome's own install banner; the Support page's button shows the
// saved prompt instead.
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  setDeferredPrompt(e);
});
window.addEventListener('appinstalled', clearDeferredPrompt);

setupAxiosInterceptors(store, { logout });
setupUtilizationTracking(store);

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        {isIE && (
          <Alert variant="danger">
            It seems you are using Internet Explorer. It is advised to use the latest version of Google Chrome, Mozilla Firefox, or Microsoft Edge when using this website.
          </Alert>
        )}
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

if (process.env.NODE_ENV === 'production') serviceWorkerRegistration.register();
